module.exports = __webpack_public_path__ + "img/pause-button.156744b1.svg";